var _rect, _path, _path2, _mask, _path3, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0803 18.56L12.1603 16.64L8.32031 20.48",
    stroke: "#404040",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6802 20.48L17.9202 14.72L12.1602 20.48",
    stroke: "#404040",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_685_686",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0798,
    cy: 12.8,
    rx: 1.28,
    ry: 1.28
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3598 12.8C13.3598 12.4023 13.6822 12.08 14.0798 12.08V16.08C15.8913 16.08 17.3598 14.6115 17.3598 12.8H13.3598ZM14.0798 12.08C14.4775 12.08 14.7998 12.4023 14.7998 12.8H10.7998C10.7998 14.6115 12.2683 16.08 14.0798 16.08V12.08ZM14.7998 12.8C14.7998 13.1976 14.4775 13.52 14.0798 13.52V9.51999C12.2683 9.51999 10.7998 10.9885 10.7998 12.8H14.7998ZM14.0798 13.52C13.6822 13.52 13.3598 13.1976 13.3598 12.8H17.3598C17.3598 10.9885 15.8913 9.51999 14.0798 9.51999V13.52Z",
    fill: "#404040",
    mask: "url(#path-4-inside-1_685_686)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIcon);
export default __webpack_public_path__ + "static/media/organizationIcon.554eaa2b70329e5d96cee743c3da035a.svg";
export { ForwardRef as ReactComponent };